















































































































































































































































































































import Vue from "vue";
import moment from "moment";

// Vue components
import TableFiltersRow from "@/components/TableHeaderFilters/TableFiltersRow.vue";
import GlobalStatusInstallationChip from "@/views/App/Components/chips/GlobalStatusInstallationChip.vue";
import ConnectivityStatusChip from "@/views/App/Components/chips/ConnectivityStatusChip.vue";
import DeviceModelChip from "@/views/App/Components/chips/DeviceModelChip.vue";
import InstallationStatusTableHeaderFilter from "@/components/InstallationStatusTableHeaderFilter.vue";
import BranchFilter from "@/components/TableHeaderFilters/BranchFilter.vue";
import TagsFilter from "@/components/TableHeaderFilters/TagsFilter.vue";
import DateRangeFilter from "@/components/TableHeaderFilters/DateRangeFilter.vue";
import MachineModelFilter from "@/components/TableHeaderFilters/MachineModelFilter.vue";
import SoftwareVersionFilter from "@/components/TableHeaderFilters/SoftwareVersionFilter.vue";
import DetailsSection from "./DetailsSection/index.vue";
import SingleUpdateTypeStatusChip from "./SingleUpdateTypeStatusChip.vue";
import ForceCheckDialogCard from "./ForceCheckDialogCard.vue";
import NewSoftwareVersionsFilter from "@/components/TableHeaderFilters/NewSoftwareVersionsFilter.vue";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";
import BulkUpdatesWizard from "./BulkUpdatesWizard/index.vue";
import InstallationResumeDialog from "@/components/InstallationResumeDialog.vue";
import ConnectivityStatusFilter from "@/components/TableHeaderFilters/ConnectivityStatusFilter.vue";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// Utility
import { dataTableItemsPerPage } from "@/utility/Constants";
import { LocalStorageManager, LocalStorageRequests } from "@/plugins/LocalStorageManager";

// Model
import { InstallationUpdate } from "@/model/data/updates/InstallationUpdate";
import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { UpdateVersionInfo } from "@/model/data/updates/UpdateVersionInfo";
import { MachineUpdate } from "@/model/data/updates/MachineUpdate";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";
import { Installation } from "@/model/data/Installation";
import { agentLockCodeTypeEnumLabel } from "@/model/data/agent/LockCodeTypeEnum";

export default Vue.extend({
    components: {
        BulkUpdatesWizard,
        TableFiltersRow,
        GlobalStatusInstallationChip,
        DeviceModelChip,
        DetailsSection,
        SingleUpdateTypeStatusChip,
        ForceCheckDialogCard,
        ColumnVisibilityFilter,
        InstallationResumeDialog,
        ConnectivityStatusChip,
    },
    data() {
        return {
            moment,
            firstTime: true,
            showDialog: false,
            selectedInstallation: null,
            prevIcon: "fas fa-chevron-left",
            nextIcon: "fas fa-chevron-right",
            NewSoftwareVersionsFilter,
            dataTableItemsPerPage,
            options: {},
            ignoreOptionsChanges: false,
            UpdateTypeEnum,
            types: { UpdateTypeEnum },
            showVersions: false,
            selectedDevices: [],
            showForceCheckDialog: false,
            forceCheckRequestedDevices: [],
            availableHeaders: [],
            dialogBulkUpdatesWizard: false,
        };
    },
    props: {
        loading: { required: true, type: Boolean },
        paginatedTotalItems: Number,
        installations: { required: true, type: Array },
        reqData: Object,
    },
    computed: {
        ...mapState({
            configuration: (state: any) => state.configuration,
            availableSoftwareFilter: (state: RootState): SoftwareFilter[] => state.application.availableSoftwareVersions,
        }),

        thirdPartySoftwareNames() {
            let names = [];
            if (this.availableSoftwareFilter.some((sw: SoftwareFilter) => sw.updateType == UpdateTypeEnum.ThirdPartySoftware))
                this.availableSoftwareFilter
                    .filter((sw: SoftwareFilter) => sw.updateType == UpdateTypeEnum.ThirdPartySoftware)
                    .forEach((sw: SoftwareFilter) => {
                        sw.versionsList.forEach((namedVersion: NamedSoftwareVersion) => {
                            if (!names.some((c) => c == namedVersion.name)) names.push(namedVersion.name);
                        });
                    });
            return names;
        },

        initialAvailableHeaders() {
            const res = [];
            res.push(
                { enabled: true, text: this.$t("common.updatesStatus"), value: "isUpToDate", sortable: false },
                { enabled: true, text: this.$t("common.installationStatus"), value: "status", sortable: false },
                { enabled: true, text: this.$t("common.connectivityStatus"), value: "connectivityStatus" },
                { enabled: true, text: this.$t("common.name"), value: "name" },
                { enabled: false, text: this.$t("common.branch"), value: "branch.name", sortable: true },
                { enabled: false, text: this.$t("common.tags"), value: "tags", sortable: false },
                { enabled: false, text: this.$t("common.last_update"), value: "lastMessage" },
                { enabled: false, text: this.$t("common.agent_ip"), value: "agentInfo.ip" },
                { enabled: false, text: this.$t("device_status.agent_remote_ip"), value: "agentInfo.remoteIp", sortable: false },
                { enabled: false, text: this.$t("common.last_agent_message"), value: "agentInfo.lastMessage", sortable: true },
                { enabled: true, text: this.$t("enum.update_type.caos"), value: "caos", sortable: false },
                { enabled: true, text: this.$t("enum.update_type.agent"), value: "agent", sortable: false },
                { enabled: false, text: this.$t("enum.update_type.inLane_sw"), value: "inlanesw", sortable: false }
            );
            this.thirdPartySoftwareNames.forEach((c) => {
                res.push({ enabled: true, text: c, value: c, sortable: false });
            });
            res.push(
                { enabled: true, text: this.$t("common.device/s"), value: "machines", sortable: false },
                { enabled: true, text: this.$t("enum.update_type.firmware"), value: "firmware", sortable: false },
                { enabled: true, text: this.$t("enum.update_type.sensor_template"), value: "sensorTemplate", sortable: false },
                { enabled: true, text: this.$t("enum.update_type.sensor_firmware"), value: "sensorFirmware", sortable: false },
                { enabled: true, text: this.$t("common.actions"), value: "actions", sortable: false, width: "150px" }
            );
            return res;
        },
        filters() {
            let filters: any = [
                {
                    headerValue: "status",
                    filterKey: "globalStatusFilter",
                    component: InstallationStatusTableHeaderFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "connectivityStatus",
                    filterKey: "connectivityStatusFilter",
                    component: ConnectivityStatusFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "branch.name",
                    filterKey: "branchNames",
                    component: BranchFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "tags",
                    filterKey: "tagValues",
                    component: TagsFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "lastMessage",
                    filterKey: "installationLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_installation_message") }),
                },
                {
                    headerValue: "agentInfo.lastMessage",
                    filterKey: "agentLastMessageDateRange",
                    component: DateRangeFilter,
                    currentSelections: [],
                    description: this.$t("common.dateRangeFilter", { property: this.$t("common.last_agent_message") }),
                },
                {
                    headerValue: "caos",
                    filterKey: UpdateTypeEnum.Caos,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Caos },
                },
                {
                    headerValue: "inlanesw",
                    filterKey: UpdateTypeEnum.InLaneSw,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.InLaneSw },
                },
                {
                    headerValue: "agent",
                    filterKey: UpdateTypeEnum.Agent,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Agent },
                },
                {
                    headerValue: "machines",
                    filterKey: "machineModels",
                    component: MachineModelFilter,
                    currentSelections: [],
                },
                {
                    headerValue: "firmware",
                    filterKey: UpdateTypeEnum.Firmware,
                    component: SoftwareVersionFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.Firmware },
                },
                {
                    headerValue: "sensorTemplate",
                    filterKey: UpdateTypeEnum.SensorTemplate,
                    component: SoftwareVersionFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.SensorTemplate },
                },
                {
                    headerValue: "sensorFirmware",
                    filterKey: UpdateTypeEnum.SensorFirmware,
                    component: SoftwareVersionFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.SensorFirmware },
                },
            ];
            this.thirdPartySoftwareNames.forEach((thirdPartySoftwareName) => {
                filters.push({
                    headerValue: thirdPartySoftwareName,
                    filterKey: thirdPartySoftwareName,
                    component: NewSoftwareVersionsFilter,
                    currentSelections: [],
                    customAttrs: { filterUpdateType: UpdateTypeEnum.ThirdPartySoftware, filterSwName: thirdPartySoftwareName },
                });
            });
            return filters;
        },
    },
    watch: {
        options: {
            handler(newOptions, oldOptions) {
                if (oldOptions != null) {
                    if (newOptions.page < oldOptions.page) this.prevIcon = "fas fa-circle-notch fa-spin";
                    if (newOptions.page > oldOptions.page) this.nextIcon = "fas fa-circle-notch fa-spin";
                }
                if (!this.ignoreOptionsChanges) this.$emit("options-changed", newOptions);
                else this.ignoreOptionsChanges = false;
            },
            deep: true,
        },
        installations: {
            handler() {
                if (this.firstTime && this.$route.query.options != null && this.$route.query.options != undefined) {
                    let queryOptions = JSON.parse(atob(this.$route.query.options));
                    this.$emit("options-changed", queryOptions);
                    this.options = queryOptions;
                }
                if (
                    this.firstTime &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != undefined &&
                    this.installations.find((i) => i.name == this.$route.query.installation) != null
                ) {
                    if (this.$route.query.showdialog) this.showDialog = this.$route.query.showdialog == "true";
                    if (this.$route.query.installation) this.selectedInstallation = this.installations.find((i) => i.name == this.$route.query.installation);

                    this.firstTime = false;
                }
            },
            deep: true,
        },
        loading(newVal) {
            if (!newVal) {
                this.prevIcon = "fas fa-chevron-left";
                this.nextIcon = "fas fa-chevron-right";
            }
        },
        showVersions(value) {
            LocalStorageManager.Write(LocalStorageRequests.ShowVersions, value as string);
        },
    },
    methods: {
        agentLockCodeTypeEnumLabel,

        handleClick(value: InstallationUpdate) {
            if (window.getSelection().toString()) {
                return;
            }
            this.showDialog = true;
            this.selectedInstallation = value;
        },

        newTabDialog(value: any) {
            if (this.reqData) {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)), reqData: btoa(JSON.stringify(this.reqData)) },
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: this.$route.name,
                    query: { showdialog: true, installation: value.name, options: btoa(JSON.stringify(this.options)) },
                });
                window.open(routeData.href, "_blank");
            }
        },

        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },

        getInstallationSwsByTypeAndName(installation: InstallationUpdate, updateType: UpdateTypeEnum, swName: string): UpdateVersionInfo[] {
            let res = [];
            if (installation.installedSoftwaresVersions)
                installation.installedSoftwaresVersions.forEach((sw) => {
                    if (swName == null && sw.updateType == updateType) res.push(sw);
                    if (swName != null && sw.updateType == updateType && sw.name == swName) res.push(sw);
                });
            return res;
        },

        getInstallationSwsByType(installation: InstallationUpdate, updateType: UpdateTypeEnum): UpdateVersionInfo[] {
            return this.getInstallationSwsByTypeAndName(installation, updateType, null);
        },

        getMachineSwsFromSerial(installation: InstallationUpdate, serialNumber: string, updateType: UpdateTypeEnum): UpdateVersionInfo[] {
            let res = [];
            let machineUpdate: MachineUpdate = new MachineUpdate();

            if (installation.updateMachines.filter((m: MachineUpdate) => m.machineSerialNumber == serialNumber).length > 0)
                machineUpdate = installation.updateMachines.filter((m: MachineUpdate) => m.machineSerialNumber == serialNumber)[0];
            // se ho trovato effettivamente le informazioni sui sw per questa macchina
            if (machineUpdate.machineSerialNumber && machineUpdate.machineSerialNumber.length > 0) {
                machineUpdate.installedSoftwaresVersions.forEach((sw) => {
                    if (sw.updateType == updateType) res.push(sw);
                });
            }
            return res;
        },

        onForceCheckRequest(devices: Installation[]) {
            this.forceCheckRequestedDevices = devices.map((c) => c.name);
            this.showForceCheckDialog = true;
        },
    },
    mounted() {
        const val = LocalStorageManager.Read(LocalStorageRequests.ShowVersions);
        this.showVersions = val != null ? JSON.parse(val) : false;
    },
});
